import { DefaultClient } from "../constant/client.default";
// import { DefaultClient } from "../constant/client.mock";
const resource = "/auth";
export const authRepository = {
  login(payload) {
    return DefaultClient.post(`${resource}/login`, payload);
  },
  loginSeller(payload) {
    return DefaultClient.post(`${resource}/loginWithId`, payload);
  },
  otpConfimRegister(payload) {
    return DefaultClient.post(`${resource}/otp/confirm-register`, payload);
  },
  otpGetCode(payload) {
    return DefaultClient.post(`${resource}/otp/get-code`, payload);
  },
  otpVerify(payload) {
    return DefaultClient.post(`${resource}/otp/verify-code`, payload);
  },
  forgetPassGetCode(payload) {
    return DefaultClient.post(`${resource}/forget-password/get-code`, payload);
  },
  forgetPassVerify(payload) {
    return DefaultClient.post(`${resource}/forget-password/verify`, payload);
  },
};
